import { Component, OnInit, inject } from '@angular/core';
import {FormsModule} from "@angular/forms";
import {ContactInformation} from "../../../../interfaces/contact-information";
import {LocaleService} from "../../../../locale/locale.service";
import {FormNavigationService} from "../../../../services/form-navigation/form-navigation.service";
import { NavigationKey } from '../../../../enums/navigation-key-type';
import {ClaimsService} from "../../../../services/claims.service";
import {FooterComponent} from "../../../common/footer/footer.component";
import {HeaderComponent} from "../../../common/header/header.component";
import { NgOptimizedImage } from "@angular/common";
import {TextInputComponent} from "../../../common/text-input/text-input.component";

@Component({
  selector: 'app-third-party-contact-information',
  imports: [
    FormsModule,
    FooterComponent,
    HeaderComponent,
    TextInputComponent
],
  templateUrl: './third-party-contact-information.component.html',
  styleUrl: './third-party-contact-information.component.css'
})
export class ThirdPartyContactInformationComponent implements OnInit {
  locale = inject(LocaleService);
  private formNavigationService = inject(FormNavigationService);
  private claimService = inject(ClaimsService);

  showError: boolean = false;
  showMandatoryFieldError: boolean = false;
  thirdPartyEntities: ContactInformation[] = []
  isDriver: boolean = false;

  ngOnInit(): void {
    this.addThirdPartyEntity();
    this.claimService.getData().subscribe(() => {
      if (this.claimService.claimReport()?.thirdPartyEntities) {
        this.thirdPartyEntities = this.claimService.claimReport().thirdPartyEntities
        this.isDriver = this.claimService.isDriver();
        if (this.thirdPartyEntities.length === 0) {
          this.addThirdPartyEntity()
        }
      }
    })
  }

  nextClicked() {
    this.evaluateShowError();
    if (!this.showError && !this.showMandatoryFieldError) {
      this.claimService.updateClaimReport({thirdPartyEntities: this.thirdPartyEntities});
      this.claimService.save().subscribe(() => {
        this.formNavigationService.navigate(NavigationKey['third-party-information']);
      });
    }
  }

  private evaluateShowError() {
    // Check if any mandatory fields are missing
    this.showMandatoryFieldError = this.thirdPartyEntities.some(entity => 
      !entity.surname || entity.surname.trim().length === 0 ||
      !entity.name || entity.name.trim().length === 0 ||
      !entity.phone || entity.phone.trim().length === 0
    );
    
    // For now, keep showError as false since we're using showMandatoryFieldError
    this.showError = false;
  }

  addThirdPartyEntity() {
    this.thirdPartyEntities.push({
      surname: null,
      name: null,
      phone: null,
      email: null
    })
  }

  removeThirdPartyEntity(item: ContactInformation) {
    this.thirdPartyEntities.splice(this.thirdPartyEntities.indexOf(item), 1);
  }
}
